<template>
  <div>
    <SideBar bar_name="Point Management" :user="user"></SideBar>

    <v-main>
      <v-container>

        <Tab :tabs="tabs">
          <template v-slot="slotProps">
            <AgentPoint v-bind="{ user: slotProps.user, tabId: slotProps.tabId, tabName: slotProps.tabName }" />
          </template>
        </Tab>

      </v-container>
    </v-main>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar";
import Tab from "@/components/Tab";
import AgentPoint from "@/components/ChangFamily/Point/AgentPoint"

export default {
  name: "Dashboard",
  components: {
    SideBar,
    Tab,
    AgentPoint
  },
  data() {
    return {
      tabs: this.$agentTabs,
      user: this.$user
    };
  }
};
</script>
